import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { t } from 'i18n'
import { ApolloError } from '@apollo/client'
import * as Sentry from '@sentry/react'
import { getMetaValue } from 'utils'
import { useNotify } from 'utils/useNotify'

const dsn = getMetaValue('sentry-dsn')
const environment = getMetaValue('environment')

if (dsn && dsn.length > 0 && environment) {
  Sentry.init({ dsn, environment })
}

export const Error: React.FC<{ error?: ApolloError; redirectTo?: string }> = ({ error, redirectTo }) => {
  const { notifyGraphQLError } = useNotify()
  const history = useHistory()

  useEffect(() => {
    if (redirectTo !== undefined) {
      history.replace(redirectTo)
    }
  }, [history, redirectTo])

  useEffect(() => {
    if (error) {
      notifyGraphQLError(error)
    }
  }, [notifyGraphQLError, error])

  if (error === undefined) {
    return <span>{t('error_occurred')}</span>
  }

  return null
}

export const ErrorMessage: React.FC<{ errorMessage: string; redirectTo?: string }> = ({ errorMessage = t('error_occurred'), redirectTo }) => {
  const { notifyError } = useNotify()
  const history = useHistory()

  useEffect(() => {
    if (redirectTo !== undefined) {
      history.replace(redirectTo)
    }
  }, [history, redirectTo])

  useEffect(() => {
    notifyError({ title: errorMessage })
  }, [notifyError, errorMessage])

  return null
}

const defaultFallback = <p>An error has occurred. Please, reload the page.</p>

export const ErrorBoundary: React.FC<React.ComponentProps<typeof Sentry.ErrorBoundary>> = ({ children, ...sentryProps }) => {
  return (
    <Sentry.ErrorBoundary fallback={defaultFallback} {...sentryProps}>
      {children}
    </Sentry.ErrorBoundary>
  )
}

export { Sentry }
